import React from "react";
import { Link, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bool } from "prop-types";
import Button from "../../common/Button";
import { downloadTestFeedback, testFeedbackUrl } from "../../api/profileApi";
import {
  isDownloadAttrSupported,
  forceDownload,
} from "../../containers/ResourceFolders/util";

const downloadFeedback = async (location) => {
  if (isDownloadAttrSupported()) {
    return downloadTestFeedback(location.state.testName).then((response) =>
      forceDownload(response, `${location.state.pdfName}`)
    );
  }
  return window.open(testFeedbackUrl(location.state.testName), "_blank");
};
const MyTestsResultPage = ({ location, isDiskAssessmentTestLoading }) => {
  return (
    <div className="row justify-content-center" style={{ minHeight: "60vh" }}>
      <div className="col-sm-9 col-lg-8 p-2">
        <h2 className="section-header">Feedback</h2>
        <section className="section-body p-1">
          <h4 className="styles__resource__title___3swKq text-center">
            Well done! Your results have been recorded.
          </h4>
          <br />
          <p className="mb-2 text-center">
            Please click the download button below to access your feedback.
          </p>
          <div className="row justify-content-center">
            <Button
              disabled={isDiskAssessmentTestLoading}
              onClick={() => {
                downloadFeedback(location);
              }}
              id="btnBasicInfoEditSubmit"
              classes="btn btn-primary"
            >
              Download
            </Button>
          </div>
          <br />
          <div className="d-flex justify-content-end">
            <Link
              to="/profile"
              className="btn btn-outline-dark text-dark hover-text-white "
            >
              Back to My Account
            </Link>
          </div>
        </section>
      </div>
    </div>
  );
};

MyTestsResultPage.propTypes = {
  isDiskAssessmentTestLoading: bool,
};

const mapStateToProps = (state) => ({
  isDiskAssessmentTestLoading: state.core.isDiskAssessmentTestLoading,
});
const withRedux = connect(mapStateToProps, null);
export default withRouter(withRedux(MyTestsResultPage));
